import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-56532abf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instruction-ballon left alert alert-light" }, " Create your new password ", -1))
const _hoisted_2 = { class: "action-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "alert-invitation",
    class: "overlay",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSkip && _ctx.handleSkip(...args)))
  }, [
    _createElementVNode("div", {
      class: "hole cursor-link",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleGoto('settings-main')))
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-light",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSkip && _ctx.handleSkip(...args)))
      }, "Got it!")
    ])
  ]))
}